// import React, { useEffect, useState } from "react";

// const API_BASE = process.env.REACT_APP_API_BASE || "";

// export default function PublicReports({ idToken }) {
//   const [items, setItems] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [err, setErr] = useState("");

//   async function load() {
//     setLoading(true);
//     setErr("");
//     try {
//       const res = await fetch(`${API_BASE}/public/submissions`, {
//         headers: {
//           "Content-Type": "application/json",
//           ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
//         },
//       });
//       const data = await res.json();
//       if (!res.ok) throw new Error(data?.error || "Failed to load public reports");
//       setItems(data.items || []);
//     } catch (e) {
//       setErr(String(e?.message || e));
//     } finally {
//       setLoading(false);
//     }
//   }

//   useEffect(() => { load(); }, []);

//   return (
//     <div className="max-w-6xl mx-auto px-4 py-8">
//       <div className="flex items-center justify-between mb-4">
//         <h1 className="text-xl font-semibold">Public Reports</h1>
//         <button
//           onClick={load}
//           disabled={loading}
//           className="rounded-lg bg-slate-900 px-3 py-2 text-white text-sm font-semibold disabled:opacity-50"
//         >
//           {loading ? "Refreshing…" : "Refresh"}
//         </button>
//       </div>

//       {err && <div className="text-red-600 mb-4">{err}</div>}

//       <div className="border rounded-xl overflow-x-auto bg-white">
//         <table className="w-full text-sm text-left">
//           <thead className="bg-gray-100">
//             <tr className="whitespace-nowrap">
//               <th className="px-3 py-2">Person</th>
//               <th className="px-3 py-2">File</th>
//               <th className="px-3 py-2">Platform</th>
//               <th className="px-3 py-2">Pull Date</th>
//               <th className="px-3 py-2">Schema</th>
//               <th className="px-3 py-2">Submitted</th>
//               <th className="px-3 py-2 text-center">Report</th>
//             </tr>
//           </thead>
//           <tbody>
//             {items.map((r) => (
//               <tr key={r.TaskId} className="border-t">
//                 <td className="px-3 py-2">{r.Name || "—"}</td>
//                 <td className="px-3 py-2">{r.UserFileName || "—"}</td>
//                 <td className="px-3 py-2">{r.Platform || "—"}</td>
//                 <td className="px-3 py-2">{r.PullDate || "—"}</td>
//                 <td className="px-3 py-2">{r.Schema || "—"}</td>
//                 <td className="px-3 py-2">{r.SubmissionTime ? new Date(r.SubmissionTime).toLocaleString() : "—"}</td>
//                 <td className="px-3 py-2 text-center">
//                   <button
//                     className="text-orange-700 font-semibold hover:underline"
//                     onClick={async () => {
//                       // easiest: backend returns ready-to-open URL in list response
//                       // OR call a second endpoint to get a signed URL
//                       if (r.PublicUrl) window.location.assign(r.PublicUrl);
//                     }}
//                     disabled={!r.PublicUrl}
//                   >
//                     Open
//                   </button>
//                 </td>
//               </tr>
//             ))}
//             {items.length === 0 && !loading && (
//               <tr><td className="px-3 py-6 text-slate-500" colSpan={7}>No public reports yet.</td></tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }



import React, { useEffect, useState } from "react";
import { fetchAuthSession } from "aws-amplify/auth";
import { useNavigate } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE || "";

export default function PublicReports() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [token, setToken] = useState("");
  const navigate = useNavigate();

  async function load() {
    setLoading(true);
    setErr("");

    try {
      const session = await fetchAuthSession();
      const tok = session.tokens?.idToken?.toString();
      if (!tok) throw new Error("Not signed in (no idToken). Please login again.");

      setToken(tok);

      const res = await fetch(`${API_BASE}/public/submissions`, {
        headers: { Authorization: `Bearer ${tok}` },
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data?.error || `Failed (HTTP ${res.status})`);

      setItems(data.items || []);
    } catch (e) {
      setErr(String(e?.message || e));
    } finally {
      setLoading(false);
    }
  }

  async function openReport(r) {
    try {
      if (!token) throw new Error("Missing auth token. Click Refresh.");

      const res = await fetch(
        `${API_BASE}/get-links/${encodeURIComponent(r.TaskId)}/signed-url?jobId=${encodeURIComponent(
          r.JobId || ""
        )}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const payload = await res.json();
      if (!res.ok) throw new Error(payload?.error || "Failed to get URL");

      if (payload?.url) window.location.assign(payload.url);
      else throw new Error("No url returned by API");
    } catch (e) {
      setErr(String(e?.message || e));
    }
  }

  useEffect(() => {
    load();
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <div className="mb-4">
        <button
          onClick={() => navigate("/main")}
          className="rounded-lg bg-purple-700 px-4 py-2 text-white text-sm font-semibold hover:bg-purple-800 shadow"
        >
          ← Back
        </button>
      </div>

      <div className="flex items-center justify-between mb-4">
        <h1 className="text-xl font-semibold">Public & Shared Reports</h1>
        <button
          onClick={load}
          disabled={loading}
          className="rounded-lg bg-purple-700 px-4 py-2 text-white text-sm font-semibold hover:bg-purple-800 shadow"
        >
          {loading ? "Refreshing…" : "Refresh"}
        </button>
      </div>

      {err && <div className="text-red-600 mb-4">{err}</div>}

      <div className="border rounded-xl overflow-x-auto bg-white">
        <table className="w-full text-sm text-left">
          <thead className="bg-gray-100">
            <tr className="whitespace-nowrap">
              <th className="px-3 py-2">Creator</th>
              <th className="px-3 py-2">Stem</th>
              <th className="px-3 py-2">File</th>
              <th className="px-3 py-2">Platform</th>
              <th className="px-3 py-2">Pull Date</th>
              <th className="px-3 py-2">Schema</th>
              <th className="px-3 py-2">Submitted</th>
              <th className="px-3 py-2">Access</th>
              <th className="px-3 py-2 text-center">Report</th>
            </tr>
          </thead>
          <tbody>
            {items.map((r) => (
              <tr key={r.TaskId} className="border-t">
                <td className="px-3 py-2">{r.Name || "—"}</td>
                <td className="px-3 py-2">{r.Stem || "—"}</td>
                <td className="px-3 py-2">{r.UserFileName || "—"}</td>
                <td className="px-3 py-2">{r.Platform || "—"}</td>
                <td className="px-3 py-2">{r.PullDate || "—"}</td>
                <td className="px-3 py-2">{r.Schema || "—"}</td>
                <td className="px-3 py-2">
                  {r.SubmissionTime ? new Date(r.SubmissionTime).toLocaleString() : "—"}
                </td>
                <td className="px-3 py-2">
                  {r.visibility === "shared" ? "Shared" : "Public"}
                </td>
                <td className="px-3 py-2 text-center">
                  <button
                    className="text-orange-700 font-semibold hover:underline"
                    onClick={() => openReport(r)}
                  >
                    Download
                  </button>
                </td>
              </tr>
            ))}

            {items.length === 0 && !loading && (
              <tr>
                <td className="px-3 py-6 text-slate-500" colSpan={9}>
                  No visible reports yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}